// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608101028/js/" + chunkId + "." + {"44":"a4331743","225":"688d1a13","481":"f917f339","486":"ef7630d0","770":"0ce367ec"}[chunkId] + ".0.2660964406890942.chunk.js";
};